import React, { memo } from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

export const DataPoints = memo(function DataPoints() {
  const dataPoints = useSelector((state) => state.serviceBookings.dataPoints);
  const isDataPointsLoading = useSelector((state) => state.serviceBookings.isDataPointsLoading);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);
  if (!dataPoints.length) return null;

  return isDataPointsLoading ? (
    <LoadingAnimation height={200} />
  ) : (
    <div className="data-points">
      {dataPoints.length
        ? dataPoints.map((dataPoint) => {
            return (
              <div key={dataPoint.label} className="data-point">
                <DataDisplay
                  key={dataPoint.label}
                  label={dataPoint.label}
                  value={Math.round(dataPoint.value)}
                  url={dataPoint.url}
                  toolTipContent={dataPoint.tooltip}
                  disableAnimation={isUserQa}
                />
              </div>
            );
          })
        : ""}
    </div>
  );
});
